import { render, staticRenderFns } from "./CircleLoader.vue?vue&type=template&id=2f2cb6e3&scoped=true&"
import script from "./CircleLoader.vue?vue&type=script&lang=js&"
export * from "./CircleLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2cb6e3",
  null
  
)

export default component.exports